import * as React from 'react'
import { inject, observer } from 'mobx-react'
import isNode from 'is-node'
import { GoSearch } from 'react-icons/go'

import Image from 'src/components/UI/Image/Image'
import Brand from 'src/stores/brand'
import BrandHeader from 'src/components/Brand/BrandHeader'
import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'
import Preview from 'src/stores/preview'
import PreviewBar from 'src/components/PreviewBar/PreviewBar'
import Ui from 'src/stores/ui'
import Menu from 'src/components/Menu/Menu'

import styles from './Header.module.scss'
import Hamburger from '../Hamburger/Hamburger'
import CartButton from '../Cart/CartButton'
import { getBrandById } from 'src/utils/brand'
import { IntlShape, injectIntl } from 'react-intl'
import messages from '../Search/messages'

type Props = {
  brand?: Brand
  config: any
  preview?: Preview
  ui?: Ui
  intl: IntlShape
  menu: any
  isStart: boolean
  activeBrand: number
}

@inject('brand', 'ui', 'preview')
@observer
class Header extends React.Component<Props> {
  handleClick = () => {
    const { ui } = this.props
    ui!.setActiveMenu('')
  }

  render() {
    const { config, preview, brand, menu, activeBrand, intl } = this.props
    let brandContent = activeBrand
      ? getBrandById(activeBrand, menu.locale)
      : null

    if (preview && preview.previewData && brand) {
      const previewBrand = brand.getPreviewBrand(
        preview.previewData,
        menu.locale
      )
      if (previewBrand) {
        brandContent = previewBrand
      }
    }

    const { formatMessage } = intl

    return (
      <React.Fragment>
        <div>{!isNode && preview && preview.isLoggedIn && <PreviewBar />}</div>
        <div className="aino-main-header">
          <header
            style={activeBrand ? {} : { height: '80px' }}
            className={styles.header}
          >
            <div className={styles.container}>
              {!activeBrand && <Hamburger white={true} />}
              <LinkComponent
                to="/"
                onClick={this.handleClick}
                ariaLabel="Go to startpage"
              >
                {!activeBrand ? (
                  <Image
                    className={styles.logotype}
                    alt={config.siteName}
                    critical
                    src={config.siteLogo.fields.file.url}
                  />
                ) : (
                    <div className={styles.logoText}>
                      <span />
                      {config.siteName}
                    </div>
                  )}
              </LinkComponent>
              {!activeBrand && <CartButton inHeader color="#ffffff" />}
              {activeBrand && (
                <LinkComponent to="/search">
                  <button className={styles.searchButton}>
                    <span className={styles.searchText}>
                      {formatMessage(messages.searchForProducts)}
                    </span>
                    <GoSearch color="white" size={14} />
                  </button>
                </LinkComponent>
              )}
            </div>
          </header>
        </div>
        <div className={styles.brand}>
          {brandContent && (
            <div>
              <BrandHeader
                brand={brandContent}
                transparent={brand.transparent}
                menu={menu}
              />
            </div>
          )}
          <div>{!brandContent && <Menu activeBrand={!!activeBrand} menu={menu} />}</div>
        </div>
      </React.Fragment>
    )
  }
}

export default injectIntl(Header)
